import styled from 'styled-components';

const colors = {
	low: {
		color: '#CC3B1F',
		background: '#FAE9E6',
	},
	middle: {
		color: '#B0C348',
		background: '#F5F8E5',
	},
	high: {
		color: '#00CC67',
		background: '#E5F8EE',
	},
};

export const Root = styled.div`
	position: relative;
	z-index: 1;
	display: inline-flex;
	align-items: center;
	// eslint-disable-next-line no-nested-ternary
	padding: ${({ $type }) => ($type === 'inline' ? 0 : $type === 'default' ? '2px 12px' : '2px 6px')};
	// eslint-disable-next-line no-nested-ternary
	height: ${({ $type }) => ($type === 'inline' ? 'auto' : $type === 'small' ? '25px' : '32px')};
	box-sizing: border-box;
	border-radius: ${({ $type }) => ($type === 'small' ? '12px' : '16px')};
	color: ${({ $segment }) => colors[$segment].color};
	background-color: ${({ $segment, $type }) =>
		$type === 'cloud' || $type === 'inline' ? '#fff' : colors[$segment].background};
	box-shadow: ${({ $type }) => ($type === 'cloud' ? '0 4px 10px rgba(0, 0, 0, 0.1)' : 'none')};
	${({ $type, theme }) => ($type === 'default' ? theme.typography.textMediumL : theme.typography.textMediumS)};

	&::before {
		content: '';
		display: ${({ $type }) => ($type === 'cloud' || $type === 'inline' ? 'block' : 'none')};
		width: 8px;
		height: 8px;
		border-radius: 50%;
		margin-right: 3px;
		background-color: currentColor;
	}

	&::after {
		content: '';
		display: ${({ $type }) => ($type === 'cloud' ? 'block' : 'none')};
		width: 8px;
		height: 8px;
		position: absolute;
		top: 100%;
		left: 50%;
		z-index: 2;
		transform: translate3d(-50%, -50%, 0) rotate(45deg);
		background-color: #fff;
	}
`;

export const Text = styled.span`
	margin-left: 3px;
	white-space: nowrap;
	color: ${({ theme }) => theme.darkGrayColor};
	${({ theme }) => theme.typography.textXS};
`;
